import axios from "axios";

export const uploadToPresignedUrl = async (uploadUrl: string, fileBlob: Blob, mimeType: string): Promise<boolean> => {
  try {
    await axios.put(uploadUrl, fileBlob, {
      headers: {
        "Content-Type": mimeType,
      },
    });

    return true;
  } catch (error) {
    console.error("Upload Failed", "Unable to upload file. Please try again.", error);
    return false;
  }
};
